/* @ngInject */
export default class ComplianceCtrl {
    constructor($state, $timeout, $rootScope, ComplianceService, NotificationService, $scope) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ComplianceService = ComplianceService;
        this.NotificationService = NotificationService;
        this.$scope = $scope;

        this.init();
    }

    init() {
        this.isBusy = false;
        this.hasDataLoaded = false;
        this.queryReason = '';
        this.rejectionReason = '';
        this.selectedMiniSubIndex = -1;
        this.miniSubTitleForOne = 'Mini-Sub Service Quote';
        this.miniSubTitleForMoreThanOne = 'Mini-Sub Service Quotes';

        this.fireCompliance = {
            queryReason: '',
            rejectionReason: ''
        };
        this.miniSubsCompliance = {
            queryReason: '',
            rejectionReason: ''
        };
        this.liftCompliance = {
            queryReason: '',
            rejectionReason: ''
        };

        this.$rootScope.$on('user-logged-in', ($event, results) => {
            this.activate();
        });
        //this.activate();
    }

    async activate() {
        this.loadAllData()
    }

    async loadAllData() {
        if (this.isBusy || this.hasDataLoaded) {
            return;
        }
        this._switchIsBusy(true);

        this.$timeout(async () => {
            this.ComplianceService.loadMiniSubTypes()
            .then(() => {
                this.$timeout(async () => {
                    await this.loadData();
                    this._swtichHasDataLoaded(true);
                    this._switchIsBusy(false);
                });
            });
        });

    }

    async loadMiniSubTypes() {
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.loadMiniSubTypes();
        } catch (error) {
        } finally {
            this._switchIsBusy(false);
        }
    }

    async loadData() {
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.loadData();
            const { miniSubQuotes } = this.ComplianceService.compliance;
            if (miniSubQuotes && miniSubQuotes.length === 1) {
                this.selectedMiniSubIndex = 0;
            }
        } catch (error) {
            const msg = 'Error loading Compliance';
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async approveFireCompliance() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.approveFireQuote();
            this.NotificationService.success('Approved.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error approving Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async rejectFireQuote() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.rejectFireQuote(this.fireCompliance.rejectionReason);
            this.NotificationService.success('Rejected.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error rejecting fire quote';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }  

    async queryFireCompliance() {
        this._registerEventHandlers();
        this._switchIsBusy(true);
        try {
            await this.ComplianceService.queryFireQuote(this.fireCompliance.queryReason);
            this.NotificationService.success('Queried.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error querying fire quote';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async cancelApproval() {
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.cancelFireApproval();
            this.NotificationService.success('Cancelled Fire Approval.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error cancelling the fire approval Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async approveMiniSubsQuote() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.approveMiniSubsQuote(this.selectedMiniSubIndex);
            this.NotificationService.success('Approved.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error approving Mini-Subs Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async approveMinisubsCommunications() {
        alert();
    }

    async rejectMiniSubsQuote() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.rejectMiniSubsQuote(
                this.selectedMiniSubIndex,
                this.miniSubsCompliance.rejectionReason
            );
            this.NotificationService.success('Rejected.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error rejecting Mini-Subs quote';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async queryMiniSubsQuote() {
        this._registerEventHandlers();
        this._switchIsBusy(true);
        try {
            await this.ComplianceService.queryMiniSubsQuote(
                this.selectedMiniSubIndex,
                this.miniSubsCompliance.queryReason
            );
            this.NotificationService.success('Queried.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error querying Mini-Subs quote';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async cancelMiniSubsApproval() {
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.cancelMiniSubsApproval();
            this.NotificationService.success('Cancelled Mini-Subs Approval.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error cancelling the Mini-Subs Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async approveMinisubsCommunications() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.approveMinisubsCommunicationsQuote();
            this.NotificationService.success('Approved.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error approving Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async rejectMinisubsCommunications() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.rejectMinisubsCommunicationsQuote();
            this.NotificationService.success('rejected.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error approving Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    async updateMinisubQuoteCommunications() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.updateMinisubQuoteStatus();
            this.NotificationService.success('Approved.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error approving Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }

    get miniSubServiceType() {
        const selectedMiniSub = this.ComplianceService.compliance.miniSubQuotes[this.selectedMiniSubIndex];
        const rawMiniSubServiceType = this.ComplianceService.compliance.miniSubTypes.find(
            (type) => type.value === selectedMiniSub.quoteType
        );
        if (rawMiniSubServiceType) {
            const { description } = rawMiniSubServiceType;
            return description;
        }

        return 'Unknown';
    }


    showMiniSub(index) {
        this.selectedMiniSubIndex = -1;

        if (index > -1) {
            this.selectedMiniSubIndex =
                index && index > -1 && index < this.ComplianceService.compliance.miniSubs.length ? index : 0;
        }
    }

    _switchIsBusy(flag) {
        this.$timeout(() => (this.isBusy = flag));
    }

    _swtichHasDataLoaded(flag) {
        this.$timeout(() => (this.hasDataLoaded = flag));
    }

    _registerEventHandlers() {
        angular.element('.compliance-page #compliance-container div[role="dialog"]').off('hide.bs.modal');
        angular.element('.compliance-page #compliance-container div[role="dialog"]').on('hide.bs.modal', () => {
            angular.element('.modal-backdrop').remove();
        });

        this.$scope.$watch('MainVM.isBusy',
            (newVal, oldVal) => {
                if (!newVal) {
                    this.$timeout(() => {
                        this.isBusy = true;
                    }, 100);
                }
            },
            true
        );


    }

    async approveLiftCompliance() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.approveLiftQuote();
            this.NotificationService.success('Approved.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error approving Compliance';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }
    
    async rejectLiftQuote() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.rejectLiftQuote(this.liftCompliance.rejectionReason);
            this.NotificationService.success('Rejected.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error rejecting lift quote';
            this.NotificationService.error.msg;
            console.error(`${msg}: ${error}`);

        } finally {
            this._switchIsBusy(false);
        }
    }

    async queryLiftCompliance() {
        this._registerEventHandlers();
        this._switchIsBusy(true);

        try {
            await this.ComplianceService.queryLiftQuote(this.liftCompliance.queryReason);
            this.NotificationService.success('Queried.');
            await this.loadData();
        } catch (error) {
            const msg = 'Error querying lift quote';
            this.NotificationService.error(msg);
            console.error(`${msg}: ${error}`);
        } finally {
            this._switchIsBusy(false);
        }
    }
}
